import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HomeService } from '../../services/home.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-append',
  templateUrl: './append.component.html',
  styleUrls: ['./append.component.scss']
})
export class AppendComponent implements OnInit {

  constructor(public bsModalRef: BsModalRef,
    public service: HomeService,
    public router: Router) { }

  ngOnInit(): void {
  }
  myDates:any;
  onClose: any;
  goods: string;
  goodsList: any = [];
  selectedGoods: any = [];
  goodsData: any = [];
  cancel() {
    this.bsModalRef.hide();
  }

  confirm() {
    this.bsModalRef.hide();
    this.onClose('confirm');

  }

  search() {
    this.service.searchGoods(this.goods,this.myDates).subscribe(
      data => {
        let code = data.resultCode;
        let info = data.resultInfo
        if (code == '100000') {
          console.log(info)
          this.goodsList = info;
          for (let index = 0; index < info.length; index++) {
            info[index]['select'] = 0;
          }
        } else {

        }
      }
    )
  }

  add() {
    this.service.getSelectedGoodsData(this.selectedGoods,this.myDates).subscribe(
      data => {
        let code = data.resultCode;
        let info = data.resultInfo
        if (code == '100000') {
          this.goodsData = info
          this.bsModalRef.hide();
          this.onClose('confirm');
        } else {

        }
      }
    )
  }

  select(data) {
    this.selectedGoods.unshift(data)
  }

}
